import React, { useState, useEffect, useMemo } from "react";
import { Container, Button, Modal, Form, Table, Collapse } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../Constant/Routes';
import PageSeoComponent from '../../SEO';
import SEO from '../../Constant/SEO.json';
import jsPDF from 'jspdf';
import logo from "../../images/shooraLogo.jpg";
import httpinvestorprofile from '../../js/http-lms_investorprofile';
import "react-datepicker/dist/react-datepicker.css";

const InvestorInputDetails = () => {
  const [pop, setPop] = useState(false);


  const [adNameQuery, setAdNameQuery] = useState('');
  const [apiData, setApiData] = useState([]);
const [error, setError] = useState(null);
const [investorData, setInvestorData] = useState(null);


 

  useEffect(() => {
    getInvestorList(adNameQuery);
  }, [adNameQuery]);



  const handleViewClick = async (invitationCodeId) => {
    try {
      const response = await httpinvestorprofile.get(
        `/investorsProgram/getInvestorProfileByInvitationId?invitationCodeId=${invitationCodeId}`
      );
      console.log(response.data,"lplplplplp")
      setInvestorData(response.data); // assuming response.data is the investor profile
      handleGenerateStyledPDF()
    } catch (error) {
      console.error("Error fetching investor profile:", error);
    }
  };



  const handleGenerateStyledPDF = async () => {
    if (!investorData) return;
  
    const pdf = new jsPDF();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let y = 20;
    const lineHeight = 10;
  
    // Load logo image as base64
    const getImageBase64 = (url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.src = url;
      });
    };
  
    const logoBase64 = await getImageBase64(logo);

    
    pdf.addImage(logoBase64, "PNG", 18, 8, 38, 15);
    y = 30; // Adjust Y after logo
  
    const checkPageBreak = () => {
      if (y + lineHeight > pageHeight) {
        pdf.addPage();
        y = 20;
      }
    };
  
    const addText = (text, isBold = false, spacing = 0) => {
      checkPageBreak();
      if (spacing) y += spacing;
      if (isBold) pdf.setFont(undefined, "bold");
      else pdf.setFont(undefined, "normal");
      pdf.text(text, 20, y);
      y += lineHeight;
    };
  
    const drawLine = (space = 5) => {
      checkPageBreak();
      y += space;
      pdf.setDrawColor(150);
      pdf.line(20, y, 190, y);
      y += space;
    };
  
    const {
      fullLegalName,
      dateOfBirth,
      countryOfBirth,
      countryOfCitizenship,
      immigrationStatus,
      passportNumber,
      investmentAmount,
      dependents = [],
      sourceOfFunds = [],
      additionalNote,
    } = investorData;
  
    pdf.setFontSize(16);
    addText("EB-5 Investor Intake Questionnaire", true, 5);
    drawLine();
  
    pdf.setFontSize(12);
    addText("Section 1: Principal Applicant Information", true, 5);
    addText(`Full Legal Name: ${fullLegalName || ""}`);
    addText(`Date of Birth: ${dateOfBirth || ""}`);
    addText(`Country of Birth: ${countryOfBirth || ""}`);
    addText(`Country of Citizenship: ${countryOfCitizenship || ""}`);
    addText(`Current Immigration Status (if in the U.S.): ${immigrationStatus || ""}`);
    addText(`Passport Number: ${passportNumber || ""}`);
    drawLine();
  
    addText("Section 2: Dependents Information", true, 5);
    pdf.setFont(undefined, "bold");
    pdf.text("Full Name", 20, y);
    pdf.text("Relationship", 60, y);
    pdf.text("DOB", 100, y);
    pdf.text("Birth Country", 130, y);
    pdf.text("Citizenship", 165, y);
    y += lineHeight;
  
    pdf.setFont(undefined, "normal");
    dependents.forEach((dep) => {
      checkPageBreak();
      pdf.text(dep.fullName || "", 20, y);
      pdf.text(dep.relationship || "", 60, y);
      pdf.text(dep.dateOfBirth || "", 100, y);
      pdf.text(dep.countryOfBirth || "", 130, y);
      pdf.text(dep.countryOfCitizenship || "", 165, y);
      y += lineHeight;
    });

    // Add extra space before drawing the line to avoid crowding
    y += 40;
    drawLine(8); // drawLine with more space
    y += 10; // more space after line

    addText("Section 3: Investment Details", true, 5);

  
  
    const drawTickOption = (checked, label) => {
      checkPageBreak();
      if (checked) {
        pdf.setFont("zapfdingbats", "normal");
        pdf.text(String.fromCharCode(51), 20, y); // ✓
      } else {
        pdf.setFont("helvetica", "normal");
        pdf.text("[ ]", 20, y);
      }
      pdf.setFont("helvetica", "normal");
      pdf.text(label, 30, y);
      y += lineHeight;
    };
  
    drawTickOption(investmentAmount === 800000, "$800,000 (Targeted Employment Area / Infrastructure Project)");
    drawTickOption(investmentAmount === 1050000, "$1,050,000 (Standard Minimum Investment)");
  
    // Start Section 4 on a new page
    drawLine();
    pdf.addPage();
    y = 20;
  
    addText("Section 4: Source of Funds - Breakdown", true, 5);
    pdf.setFont(undefined, "bold");
    pdf.text("Source", 20, y);
    pdf.text("Amount (USD)", 90, y);
    pdf.text("Docs?", 160, y);
    y += lineHeight;
    
    pdf.setFont(undefined, "normal");
    
    const fundSources = [
      "Personal Savings",
      "Employment Income",
      "Business Earnings",
      "Gift from Family/Friends",
      "Sale of Property or Assets",
      "Loan Proceeds",
      "Inheritance",
      "Crypto/Investment Gains",
      "Other",
    ];
    
    fundSources.forEach((sourceType) => {
      const source = sourceOfFunds.find((s) => s.sourceType === sourceType);
      const amount = source ? `$${source.amountUsd.toLocaleString()}` : "-";
    
      checkPageBreak();
      pdf.text(sourceType, 20, y);
      pdf.text(amount, 90, y);
    
      // Docs? column with ticks:
      if (source) {
        // Draw "Yes" checkbox
        pdf.setFont("zapfdingbats");
        if (source.supportingDocsAvailable) {
          pdf.text(String.fromCharCode(51), 160, y); // tick ✓
        } else {
          pdf.text(" ", 160, y); // empty
        }
    
        pdf.setFont("helvetica");
        pdf.text("Yes", 165, y);
    
        // Draw "No" checkbox
        pdf.setFont("zapfdingbats");
        if (!source.supportingDocsAvailable) {
          pdf.text(String.fromCharCode(51), 190, y); // tick ✓
        } else {
          pdf.text(" ", 190, y); // empty
        }
        pdf.setFont("helvetica");
        pdf.text("No", 195, y);
      } else {
        // No source data: empty checkboxes
        pdf.setFont("helvetica");
        pdf.text("[ ] Yes  [ ] No", 160, y);
      }
    
      y += lineHeight;
    });
    
    const total = sourceOfFunds.reduce((sum, s) => sum + (s.amountUsd || 0), 0);
    const totalText = sourceOfFunds.length
      ? `Total (must equal $800,000): $${total.toLocaleString()}`
      : "Total (must equal $800,000):";
    addText(totalText, false, 5);
    drawLine();

    
  
    addText("Section 5: Additional Notes / Explanations", true, 5);
    const note = additionalNote?.notes || "";
    const lines = pdf.splitTextToSize(note, 170);
    lines.forEach((line) => {
      checkPageBreak();
      pdf.text(line, 20, y);
      y += lineHeight;
    });

    const pdfBlobUrl = pdf.output('bloburl');
window.open(pdfBlobUrl, '_blank');
  
    // pdf.save("EB5-Investor-Questionnaire.pdf");
  };
  




  const getInvestorList = (fullLegalName) => {
    httpinvestorprofile
      .get(`/investorsProgram/getInvestorsList`, {
        params: { fullLegalName: fullLegalName || '' },
      })
      .then((response) => {
        console.log('Fetched investor list:', response.data);
        if (response.data && response.data.length > 0) {
          setApiData(response.data);
          setError(null);
        } else {
          setApiData([]);
          setError('No records found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setError('Error fetching data.');
      });
  };



 





  const navigate = useNavigate();

 

  const navToPrevRoute = () => {
    navigate(ROUTES.MY_PROPERTIES);
  };

 
  

  
  

 


 
  

















  

  
  



   

 

  return (
    <>


{pop && (
        <div className="position-fixed P-Update-Success-1 d-flex justify-content-center align-items-center">
          <div className=" d-flex flex-column justify-content-center align-items-center P-Update-Success-2 ">
            <div>
              <img
                src={require("../../images/Tick.png")}
                alt="success"
                className="img-fluid"
              />
            </div>
            <p className="text-center w213 ">
            Record Updated Successfully
            </p>
          </div>
        </div>
      )}


      <PageSeoComponent {...SEO['my-properties']} />
      <Container className="pt-5">
        <div className="my-models-title d-flex justify-content-between mb-4 mt-5">
          <div className="d-flex">
            <div className="d-flex align-items-center mt-4 pointer" onClick={navToPrevRoute}>
              <img className="pe-3 backarrow" src={require('../../images/leftarrow.png')} alt="back" />
              <h3 className=" mt-2">Investor Input</h3>
            </div>
          </div>
        </div>

    
 













      <Form.Group className="mb-4">
  <Form.Label>Search by Legal Name</Form.Label>
  <Form.Control
    type="text"
    placeholder="Search by Legal Name"
    value={adNameQuery}
    onChange={(e) => setAdNameQuery(e.target.value)}
  />
</Form.Group>

        {/* Table */}
        <div className="scrollme-container mt-4 mb-5 mx-md-0 mx-3">
  <div className="scrollme">
    <Table striped bordered hover>
      <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
        <tr>
          <th style={{ fontSize: '16px' }}>View</th>
          <th style={{ fontSize: '16px' }}>Legal Name</th>
          <th style={{ fontSize: '16px' }}>ID</th>
          <th style={{ fontSize: '16px' }}>Email</th>
          <th style={{ fontSize: '16px' }}>Created Date</th>
          <th style={{ fontSize: '16px' }}>Submitted Status</th>
        </tr>
      </thead>
      <tbody>
        {apiData.length > 0 ? (
          apiData.map((item, index) => (
            <tr key={index}>
              <td>
                <Button variant="primary" onClick={() => handleViewClick(item.invitationCodeId)}>
                  View
                </Button>
              </td>
              <td>{item.fullLegalName || '-'}</td>
              <td>{item.id || '-'}</td>
              <td>{item.email || '-'}</td>
              <td>{new Date(item.createdAt).toLocaleString() || '-'}</td>
              <td>{item.submitted ? 'Yes' : 'No'}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={6} style={{ textAlign: 'center' }}>
              {error || 'No records found.'}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
</div>







      </Container>
    </>
  );
};

export default InvestorInputDetails;
